import axiosInstance from '../Api/axiosInstance';

// Register new user
export const register = (userData) =>
	axiosInstance.post('/auth/register', userData);

// Login user
export const login = (userData) => axiosInstance.post('/auth/login', userData);

// Request password reset
export const requestPasswordReset = (email) =>
	axiosInstance.post('/auth/request-password-reset', { email });

// Reset password
export const resetPassword = (token, newPassword) =>
	axiosInstance.post('/auth/reset-password', { token, newPassword });

export const logout = () => axiosInstance.post('/auth/logout');

export const verifyPassword = (password) =>
	axiosInstance.post('/auth/verify-password', { password });
